import { DailyOrderStatus, locations } from 'constant'

const calculateQuantityPicked = (products: any[]) => {
  return products.reduce((sum, item) => sum + item.quantityPicked, 0)
}
const calculateQuantityRemaining = (products: any[]) => {
  return products.reduce((sum, item) => sum + item.quantityRemaining, 0)
}
const calculateQuantityReceived = (products: any[]) => {
  return products.reduce((sum, item) => sum + item.quantityReceived, 0)
}
const calculateQuantityNotReceived = (products: any[]) => {
  return products.reduce((sum, item) => sum + item.quantityRemaining, 0)
}
const isObjectNotEmpty = (obj: object): boolean => {
  return Object.keys(obj).length !== 0
}

const getPickingBackColor = (product: any) => {
  if (product.quantityPicked === 0 && product.quantityRemaining !== 0) {
    return 'rgba(252, 207, 207, 1)'
  }
  if (product.quantityPicked > 0 && product.quantityRemaining > 0) {
    return 'rgba(255, 255, 187, 1)'
  }
  if (product.quantityRemaining === 0) {
    return 'rgba(217, 252, 210, 1)'
  }
  return '#ffffff'
}
const getReceivingBackColor = (product: any) => {
  if (product.quantityReceived === 0 && product.quantityRemaining !== 0) {
    return 'rgba(252, 207, 207, 1)'
  }
  if (product.quantityReceived > 0 && product.quantityRemaining > 0) {
    return 'rgba(255, 255, 187, 1)'
  }
  if (product.quantityRemaining === 0) {
    return 'rgba(217, 252, 210, 1)'
  }
  return '#ffffff'
}

const getTransferOrderBackColor = (product: any) => {
  if (product.quantityPicked === 0 && product.quantityRemaining !== 0) {
    return 'rgba(252, 207, 207, 1)'
  }
  if (product.quantityPicked > 0 && product.quantityRemaining > 0) {
    return 'rgba(255, 255, 187, 1)'
  }
  if (product.quantityRemaining === 0) {
    return 'rgba(217, 252, 210, 1)'
  }
  return '#ffffff'
}

const getDailyOrderStatusLabel = (status: string) => {
  switch (status) {
    case DailyOrderStatus.PendingFulfilled:
      return 'Pending Fulfilled'
    case DailyOrderStatus.Finished:
      return 'Finished'
    case DailyOrderStatus.PendingCancelled:
      return 'Pending Cancelled'
    case DailyOrderStatus.CancelConfirmed:
      return 'Cancel Confirmed'
    case DailyOrderStatus.FailedToCancel:
      return 'Failed to Cancel'
    default:
      return status
  }
}

const scanFBALabelColor = (product: any) => {
  if (product.quantityRemaining === product.quantity) {
    return 'rgba(252, 207, 207, 1)'
  }
  if (
    product.quantityRemaining > 0 &&
    product.quantityRemaining < product.quantity
  ) {
    return 'rgba(255, 255, 187, 1)'
  }
  if (product.quantityRemaining === 0) {
    return 'rgba(217, 252, 210, 1)'
  }
  return '#ffffff'
}

const setElementToTop = (array: any[], index: number) => {
  if (index > 0) {
    const elementToMove = array.splice(index, 1)[0]
    array.unshift(elementToMove)
  }
  return array
}

const playErrorAlertAudio = () => {
  const audio = new Audio('/audio/error.wav')
  audio.play()
}

const getLocationNameById = (locationId: number) => {
  const result = locations.find(location => location.id === locationId)
  return result ? result.value : 'N/A'
}

/**
 * Get company name from pathname
 * @param pathname Current pathname
 * @param companyOptions Company options object
 * @param defaultCompany Default company name if no match found
 * @returns Company name (QTE, FCS, ACE, etc.) or default company
 */
const getCompanyFromPathname = (
  pathname: string,
  companyOptions: Record<string, { name: string; path: string }>,
  defaultCompany: string = 'QTE'
): string => {
  // Find the first company whose path is included in the pathname
  const matchedCompany = Object.values(companyOptions).find(option =>
    pathname.includes(option.path)
  )
  return matchedCompany?.name || defaultCompany
}

const getBatchLabelByIndex = (index: number): string => {
  if (!Number.isInteger(index) || index < 0) return ''
  let value = index + 1
  let label = ''
  while (value > 0) {
    const rem = (value - 1) % 26
    label = String.fromCharCode(65 + rem) + label
    value = Math.floor((value - 1) / 26)
  }
  return label
}

const getBatchPrefixFromBoxCode = (boxCode: string): string => {
  const match = String(boxCode ?? '')
    .trim()
    .toUpperCase()
    .match(/^[A-Z]+/)
  return match ? match[0] : ''
}

export {
  calculateQuantityPicked,
  calculateQuantityRemaining,
  calculateQuantityReceived,
  calculateQuantityNotReceived,
  isObjectNotEmpty,
  getPickingBackColor,
  getReceivingBackColor,
  setElementToTop,
  getTransferOrderBackColor,
  scanFBALabelColor,
  playErrorAlertAudio,
  getDailyOrderStatusLabel,
  getLocationNameById,
  getCompanyFromPathname,
  getBatchLabelByIndex,
  getBatchPrefixFromBoxCode
}
